(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  // PDP options and lifestyle galleries establish the final layout after hydration.
  // Observe their videos then, so a temporarily collapsed section cannot start a download.
  let productReady = !document.querySelector('[data-product-gallery-catalog]')

  const activate = (video) => {
    if (reducedMotion.matches) {
      video.autoplay = false
      video.controls = true
    }
    const source = video.querySelector('source[data-src]')
    if (source) {
      source.src = source.dataset.src
      delete source.dataset.src
      video.load()
    }
    if (!reducedMotion.matches) {
      // Autoplay can be refused by the browser even for muted videos.
      video.play().catch(() => { video.controls = true })
    }
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) activate(target)
        else target.pause()
      })
    }, { rootMargin: '0px' })
    : null

  const observe = (root) => {
    if (!productReady) return
    root.querySelectorAll('video[data-lazy-video]').forEach((video) => {
      if (observer) observer.observe(video)
      else activate(video)
    })
  }

  observe(document)
  window.addEventListener('floyd:product:hydrated', () => {
    productReady = true
    requestAnimationFrame(() => requestAnimationFrame(() => observe(document)))
  }, { once: true })
  document.addEventListener('shopify:section:load', (event) => observe(event.target))
  document.addEventListener('floyd:media:visible', (event) => observe(event.target))
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('video[data-lazy-video]').forEach((video) => {
      observer?.unobserve(video)
      video.pause()
    })
  })
})()
